<template>
    <div id="NotLoggedIn">
        <Login />
    </div>
</template>

<script>
    // @ is an alias to /src
    import Login from "@/components/NotLoggedIn/Login.vue";
    export default {
        name: "NotLoggedIn",
        components: {
            Login,
        },
        data() {
            return {
                screen: 0,
                showWarning: null
            };
        },

    };
</script>
<style lang="less">
    #NotLoggedIn {
        background-image: url(/img/auth-bg.png);
        background-size: cover;
        background-position: bottom;
        position: relative;
        min-height: 100vh;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin: auto;
        &:after{
            //IE vertical centre
            content:'';
            min-height:inherit;
            font-size:0;
        }
        .form-logo {
            max-width: 300px;
        }
        .login, .reset-password {
            .form-logo {
                padding-bottom: 100px;
            }
        }
        .custom-checkbox{
            a{
                color: #8d8e92;
                text-decoration: underline;
            }
        }
    }
</style>
